<div class="ss-artist">
  <div class="ss-artist--profile">
    <img [src]="artist.photo + '?h=100'">
  </div>
  <div class="ss-artist--info" ngClass="{'info-spread': spread}">
    <div class="info-name ss-truncate">{{artist.name}}</div>
    <div class="info-songs" *ngIf="!spread">{{artist.stats.songs}} Song<ng-container *ngIf="artist.stats.songs != 1">s</ng-container></div>
  </div>
  <div class="artist-songs" *ngIf="spread">{{artist.stats.songs}} Song<ng-container *ngIf="artist.stats.songs != 1">s</ng-container></div>
</div>